import { render, staticRenderFns } from "./IngestionSettings.vue?vue&type=template&id=779d03be&scoped=true"
import script from "./IngestionSettings.vue?vue&type=script&lang=js"
export * from "./IngestionSettings.vue?vue&type=script&lang=js"
import style0 from "./IngestionSettings.vue?vue&type=style&index=0&id=779d03be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779d03be",
  null
  
)

export default component.exports